export default "__VITE_ASSET__DLxAMRJN__$_?url__"